import styled from '@emotion/styled'
import Button from '../Button'

export const CustomButton = styled(Button)`
  font-family: inherit;
  max-height: 48px;
  & img {
    height: 30px;
  }
  &:disabled {
    cursor: not-allowed;
  }
`
